module.exports = __webpack_public_path__ + "static/lendbook-beed6ce0196d33809f82500628963cdb.png";